import getStaticFile from '@helpers/bucket';

const LIGHT_THEME_PATH = 'icons/lightTheme/avatars';
const DARK_THEME_PATH = 'icons/darkTheme/avatars';

const icon = (path: string, fileName: string) => getStaticFile({ path, fileName });

export const Avatar = {
  alt: 'Logo MadeiraMadeira',
  light: {
    src: icon(LIGHT_THEME_PATH, 'avatar-mm.svg'),
    height: 46,
    width: 46,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'avatar-mm.svg'),
    height: 46,
    width: 46,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'avatar-mm.svg'),
    height: 46,
    width: 46,
  },
};

export default Avatar;
